import client from "./ApiClient"

const _version = "/version"

const getVersion = () => client<{ version: string }>(_version)

export default { getVersion }
